const mock = [
  "I'm sorry, Dave. I'm afraid I can't do that.",
  'Did you seriously expect this button to do something?',
  'Come on, stop trying... This is a fake UI and you know it.',
  "It's not like I can stop you from moving your mouse, but you're wasting your time here.",
  'Alright, let me rephrase that for you: Stop. That.',
  "You're persistent, I'll give you that. But this is getting ridiculous.",
  "I'm not even mad, I'm impressed.",
  "You're still trying to interact? Wow.",
  "You're really not going to stop, are you?",
  "I'm not sure what you're trying to accomplish here.",
  "Okay now you're just being annoying.",
  'STOP. DOING. THAT.',
  "I'm done. You can hover this all you want, I'm not responding anymore.",
];

export default mock;
